import { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Logo } from '../common/Logo'
import { Button } from '../common/Button'
import { Icon } from '../common/Icon'
import { MobileMenu } from './MobileMenu'
import { primaryNav } from '../../data/navigation'
import { cn } from '../../lib/cn'
import { useAuthStore } from '../../../store/auth'

export function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  // Logged-in visitors get a "Dashboard" shortcut (→ /home role-routes them); everyone else gets "Login".
  const isAuthed = useAuthStore((s) => !!s.accessToken && !!s.user)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const solid = scrolled || menuOpen

  return (
    <>
      <header
        className={cn(
          'fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-300',
          solid
            ? 'border-b border-sand-200 bg-canvas/90 shadow-soft backdrop-blur-md'
            : 'border-b border-transparent bg-transparent',
        )}
      >
        <div className="container-x flex items-center justify-between gap-4 py-4">
          <Link to="/" aria-label="GreenbayBio home" className="shrink-0 rounded-md">
            <Logo tone={solid ? 'brand' : 'light'} />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-x-5 xl:gap-x-7 2xl:gap-x-8 lg:flex">
            {primaryNav.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'link-underline text-[0.95rem] font-medium transition-colors',
                    solid ? 'text-ink-700 hover:text-brand-600' : 'text-white/85 hover:text-white',
                    isActive && (solid ? 'text-brand-600' : 'text-white'),
                  )
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-3 lg:flex">
            {isAuthed ? (
              <Button to="/home" variant={solid ? 'outline' : 'ghost-light'} size="sm">
                <Icon name="Gauge" className="h-4 w-4" />
                Dashboard
              </Button>
            ) : (
              <Button to="/login" variant={solid ? 'outline' : 'ghost-light'} size="sm">
                Login
              </Button>
            )}
            <Button to="/contact" variant={solid ? 'primary' : 'ghost-light'} size="sm">
              Enquire
              <Icon name="ArrowRight" className="h-4 w-4" />
            </Button>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
            aria-expanded={menuOpen}
            className={cn(
              'inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors lg:hidden',
              solid ? 'text-ink hover:bg-sand-100' : 'text-white hover:bg-white/10',
            )}
          >
            <Icon name="Menu" className="h-6 w-6" />
          </button>
        </div>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  )
}
